import React, { PropsWithChildren } from 'react'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'

interface Props {
  title: string;
  textApply?: string;
  textCancel?: string;
}

function BusinessTravellerSelectMobileModal(props: PropsWithChildren<Props>) {
  const {
    title,
    children,
    textApply = 'Apply',
    textCancel = 'Cancel',
  } = props

  return (
    <ModalBase mode="drawer">
      <form onSubmit={e => e.preventDefault()}>
        <ModalHeader title={title}/>
        <ModalBody>
          <ModalContent>
            {children}
          </ModalContent>
        </ModalBody>
        <ModalFooter
          primaryActionProps={{
            children: textApply,
            type: 'submit',
            'data-testid': 'view-offers-filter-button',
          }}
          secondaryActionProps={{
            children: textCancel,
          }}
        >
        </ModalFooter>
      </form>
    </ModalBase>
  )
}

export default BusinessTravellerSelectMobileModal
